// extracted by mini-css-extract-plugin
module.exports = {"heading":"ScanTimers_heading__3GCwb","subTitle":"ScanTimers_subTitle__143lk"};